import { render, staticRenderFns } from "./openCustomers.vue?vue&type=template&id=4ff7d61a&scoped=true"
import script from "./openCustomers.vue?vue&type=script&lang=js"
export * from "./openCustomers.vue?vue&type=script&lang=js"
import style0 from "./openCustomers.vue?vue&type=style&index=0&id=4ff7d61a&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ff7d61a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Prod-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4ff7d61a')) {
      api.createRecord('4ff7d61a', component.options)
    } else {
      api.reload('4ff7d61a', component.options)
    }
    module.hot.accept("./openCustomers.vue?vue&type=template&id=4ff7d61a&scoped=true", function () {
      api.rerender('4ff7d61a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/openCustomers/openCustomers.vue"
export default component.exports